import { render, staticRenderFns } from "./healthNewsTeaser.vue?vue&type=template&id=3808916f&"
var script = {}
import style0 from "./healthNewsTeaser.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3808916f')) {
      api.createRecord('3808916f', component.options)
    } else {
      api.reload('3808916f', component.options)
    }
    module.hot.accept("./healthNewsTeaser.vue?vue&type=template&id=3808916f&", function () {
      api.rerender('3808916f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/healthNewsTeaser/healthNewsTeaser.vue"
export default component.exports